import { httpCreate } from './http';

const http = httpCreate('/srv/trxorder');

export const trxorder = {
	// 获取多维的价格列表
	getPriceListMulti() {
		return http.get('/photo/getPriceList/admin');
	},
	addOrder(data, params) {
		// 统一添加下单渠道
		data.buyOrigin = '直播PC';
		return http.post('/addOrder', data, { params });
	},
	video(data) {
		return http.post('/video/addOrder', data);
	},
	getOrderResult(data) {
		return http.post('/getOrder', data);
	},
	getOrderList(data, params) {
		return http.post('/selectByParams', data, { params });
	},
	getAgencyList(data, params) {
		return http.post('/agency', data, { params });
	},
	getPriceList() {
		return http.get('/getPriceList');
	},
	//type
	getActualPrice(count, params) {
		return http.get(`/getPrice/${count}`, { params });
	},
	getTotalAmount() {
		return http.get('/getTotalAmount');
	},
	// pageNum, pageSize
	getFundListPage(params) {
		return http.get('/getFundList', { params });
	},
	//获取打赏榜列表
	getRewardList(activityId, params) {
		return http.get(`/getRewardList/${activityId}`, { params });
	},
	//获取直播收益
	getSaasCount(params) {
		return http.get('/getTotalAmount', { params });
	},
	invitationCard(activityId, data) {
		return http.post(`/invitationCard/${activityId}`, data);
	},
	// 充值
	recharge(data) {
		return http.post('/recharge', data);
	},
	marketingRecharge(data) {
		return http.post('/marketing/recharge', data);
	},
	// 传入直播间创建者的id,获取余额
	getTotalAmountByUserId(userId) {
		return http.get(`/getTotalAmount/${userId}`);
	},
	// 切换支付方式 - 返回的二维码相关信息
	changeCode(orderNo, payType) {
		return http.post(`/changePayType?orderNo=${orderNo}&type=${payType}`);
	},
	// 判断是否根据余额支付成功
	confirmPay(orderNo) {
		return http.post(`/confirmPay?orderNo=${orderNo}`);
	},
	/** 升级直播间
	 * @param { Number } activityId 直播间ID
	 * @param { Number } data.fromType 0-微信 1-支付宝
	 * @returns
	 */
	upgrade(activityId, data) {
		return http.post(`/upgrade/${activityId}`, data);
	},
};
